import {useMemo} from 'react';
import {useIVStore} from '../../../store/useIVStore';
import {getDocumentType} from '../../../store/selectors/getDocumentType';
import {getDocumentNationality} from '../../../store/selectors/getDocumentNationality';
import {resolveDocumentVisual} from './resolveDocumentVisual';

function useAutofillDocumentVisual() {
  const documentChoice = useIVStore(getDocumentType);
  const nationality = useIVStore(getDocumentNationality);

  return useMemo(
    () => resolveDocumentVisual({countryCode: nationality, documentChoice}),
    [nationality, documentChoice],
  );
}

export {useAutofillDocumentVisual};
